import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import App from "./App";
import "./styles/index.css";

const container = document.getElementById("root");
if (!container) throw new Error("index.html is missing the #root element.");

// No gate in front of the app: this build serves one fixed library, so there is
// no session to bootstrap and no sign-in screen to show first.
createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
